import { TenantType } from 'customers/tenants-common-view/lib/schema/Tenant.types';
import {
  ShowLabelValue,
  ShowLabelValueProps,
} from 'common/custom-components/lib/components/ShowLabelValue';
import {
  Card,
  CardContent,
  CardHeader,
  Stack,
  Typography,
  Divider,
} from '@mui/material';
import { useTenantInfraDetails } from './useTenantInfraDetails';
import { infraDetailsCardStyles } from './styles';
import {
  RESOURCE_FIELD_MAPPINGS,
  extractResourceFieldsFromArray,
  extractVpcResourceFieldsFromArray,
} from './fieldMappings';

interface TenantInfraDetailsProps {
  tenant: TenantType;
}

export default function TenantInfraDetails(props: TenantInfraDetailsProps) {
  const { tenant } = props;
  const {
    infraInfo,
    eksCloudResourceUrl,
    domain,
    ec2InstanceTailscaleIp,
    sqsResource,
    vpcResource,
  } = useTenantInfraDetails({ tenant });

  const sqsFieldsArray = Array.isArray(sqsResource)
    ? extractResourceFieldsFromArray(sqsResource, RESOURCE_FIELD_MAPPINGS.sqs)
    : [];

  const vpcFieldsArray = Array.isArray(vpcResource)
    ? extractVpcResourceFieldsFromArray(vpcResource)
    : [];

  const cardProps: ShowLabelValueProps[] = [
    {
      label: 'Namespace',
      value: infraInfo?.eksNamespace || '',
    },
    {
      label: 'Cloud Resource URL',
      value: eksCloudResourceUrl || '-',
      linkName: eksCloudResourceUrl || '-',
    },
    {
      label: 'Username',
      value: `for_tenant-${domain}_tessell `,
    },
    {
      label: 'Database Name',
      value: `tenant-${domain}_tessell `,
    },
    {
      label: 'IP Address(Tailscale)',
      value: ec2InstanceTailscaleIp || '-',
    },
  ];

  return (
    <Card>
      <CardHeader
        title={
          <Typography sx={infraDetailsCardStyles.title}>
            Tenant Infrastructure Details
          </Typography>
        }
        style={infraDetailsCardStyles.cardHeader}
      />
      <CardContent>
        <Stack spacing={2} sx={infraDetailsCardStyles.card}>
          <Stack>
            <Typography sx={infraDetailsCardStyles.subHeading}>
              Kubernetes Cluster
            </Typography>
            <Stack spacing={1}>
              {cardProps?.map((item, index) => {
                if (index <= 1) {
                  return (
                    <ShowLabelValue
                      label={item?.label}
                      value={item?.value}
                      linkName={item?.linkName}
                    />
                  );
                }
                return <></>;
              })}
            </Stack>
          </Stack>
          <Divider sx={{ my: 2, borderBottomWidth: 2 }} />
          <Stack>
            <Typography sx={infraDetailsCardStyles.subHeading}>
              Metadata Repository
            </Typography>
            <Stack spacing={1}>
              {cardProps?.map((item, index) => {
                if (index > 1) {
                  return (
                    <ShowLabelValue
                      label={item?.label}
                      value={item?.value}
                      linkName={item?.linkName}
                    />
                  );
                }
                return <></>;
              })}
            </Stack>
          </Stack>
          <Divider sx={{ my: 2, borderBottomWidth: 2 }} />
          <Stack>
            <Typography sx={infraDetailsCardStyles.subHeading}>
              Queue Resource Details
            </Typography>
            <Stack spacing={2}>
              {sqsFieldsArray.length > 0 ? (
                sqsFieldsArray.map((sqsFields, index) => (
                  <Stack key={index} spacing={1}>
                    {index > 0 && <Divider sx={{ my: 1 }} />}
                    {sqsFields.map((field) => (
                      <ShowLabelValue
                        key={field.label}
                        label={field.label}
                        value={field.value}
                      />
                    ))}
                  </Stack>
                ))
              ) : (
                <ShowLabelValue label="SQS Resource Details" value="-" />
              )}
            </Stack>
          </Stack>
          <Divider sx={{ my: 2, borderBottomWidth: 2 }} />
          <Stack>
            <Typography sx={infraDetailsCardStyles.subHeading}>
              VPC Resource Details
            </Typography>
            <Stack spacing={2}>
              {vpcFieldsArray.length > 0 ? (
                vpcFieldsArray.map((vpcFields, index) => (
                  <Stack key={index} spacing={1}>
                    {index > 0 && <Divider sx={{ my: 1 }} />}
                    {vpcFields.map((field) => (
                      <ShowLabelValue
                        key={field.label}
                        label={field.label}
                        value={field.value}
                      />
                    ))}
                  </Stack>
                ))
              ) : (
                <ShowLabelValue label="VPC Resource Details" value="-" />
              )}
            </Stack>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
